import React from 'react';

import { getIn } from '@gogame/form';

import { ViewStateContext } from '../ViewStateContext';

export const useViewStateByPath = (path = '') => {
  const values = React.useContext(ViewStateContext);
  return getIn(values, path);
};
